//
// Copyright (c) 2024 Comcast
//

import PropTypes from 'prop-types'

import Badge from 'components/Shared/Badge/Index'

const SidebarBadges = ({ badges }) => {
  return badges.map(badge => {
    const { value, color, title } = badge

    return (
      <Badge key={value || title} color={color} margin='2px'>
        {title}
      </Badge>
    )
  })
}

SidebarBadges.propTypes = {
  badges: PropTypes.array,
}

export default SidebarBadges
